import { Component, inject, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseFormComponent } from '../../../shared/class/base-form.class';
import { TimeZoneOffset } from '../../../shared/enums/time-zone.enum';
import { LANGUAGES, ORG_STATUS } from '../../../shared/constansts/app.const';
import { MessageType } from '../../../shared/enums/message-type.enum';
import { SelectOption } from '../../../shared/models/select-option.model';
import { ApiResponse } from '../../../shared/interfaces/api-response.interface';
import { User } from '../../../shared/models/user.model';
import { AppHttpService } from '../../../shared/services/app-http.service';
import { FileUpload } from 'primeng/fileupload';
import { WindowRefService } from '../../../shared/services/window-ref.service';

@Component({
  selector: 'app-add-org',
  templateUrl: './add-org.component.html',
  styleUrls: ['./add-org.component.scss']
})
export class AddOrgComponent extends BaseFormComponent implements OnInit {
  @ViewChild('fileUpload') fileUpload: FileUpload | undefined;

  timeZoneOptions = Object.keys(TimeZoneOffset)
    .filter(key => isNaN(Number(key)))
    .map(key => ({
      label: key,
      value: TimeZoneOffset[key as keyof typeof TimeZoneOffset]
    }));

  addOrganizationForm: FormGroup;
  languagesOptions = LANGUAGES;
  orgStatusOptions = ORG_STATUS;
  usersList: any[] = [];
  logo: File | null = null;

  constructor(protected override fb: FormBuilder,     private windowService: WindowRefService,
  ) {
    super();
    this.addOrganizationForm = this.fb.group({
      code: new FormControl<string | undefined>(undefined, [Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$')]),
      name: new FormControl('', [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(40),
        Validators.pattern('^[a-zA-Z0-9-+\\s/\\_]*$')
      ]),
      description: new FormControl<string | undefined>(undefined),
      adminEmail: new FormControl<string | undefined>(undefined, [Validators.required, Validators.email]),
      adminPhone: new FormControl<string | undefined>(undefined),
      credits: new FormControl<number>(10),
      orgStatus: new FormControl<string | undefined>(ORG_STATUS[0]),
      logo: new FormControl<File | null>(null),
      gstInNumber: new FormControl<string | undefined>(undefined),
    });
  }

  ngOnInit(): void {
    this.getOrgRecords();
  }

  onUpload(event: any) {
    this.logo = event.files[0];
    this.addOrganizationForm.get('logo')?.setValue(this.logo);
    this.notificationService.notify('Logo Uploaded Successfully', MessageType.Success);
  }

  async getOrgRecords() {

    let response:ApiResponse<any> = await this.httpService.httpRequest<User>(
      "user",
      "find-all-and-count-by-admin",

     );
     if(response.status && response.data){
      this.usersList=response.data![0] ?? [];
     }
  }


  async addOrg(){
    if(this.addOrganizationForm.valid){
      let payload=this.addOrganizationForm.value;
       let response:ApiResponse<any> = await this.httpService.httpRequest<any>(
         "organization",
         "add",
         payload
        );
        if(response.status && response.data){
       this.notificationService.showSuccess('Organization Added Successfully!');
       this.addOrganizationForm.reset();
       this.fileUpload?.clear();
       this.router.navigateByUrl("/settings/org");
        }else{
         this.notificationService.showError('Unable to Add Organization');
        }
    }
  }
}
